import { ProviderMeta, SocialPage } from '../../shared/types/socialTypes';
import { RootState } from '../store';

export const selectProviderState = (state: RootState, provider: string) =>
    state.social[provider] || { pages: [], meta: null, loading: false, error: null };

export const selectProviderPages = (state: RootState, provider: string): SocialPage[] =>
    state.social[provider]?.pages || [];

export const selectProviderMeta = (state: RootState, provider: string): ProviderMeta | null =>
    state.social[provider]?.meta || null;

export const selectProviderLoading = (state: RootState, provider: string): boolean =>
    state.social[provider]?.loading || false;

export const selectProviderError = (state: RootState, provider: string): string | null =>
    state.social[provider]?.error || null;
